export interface IMyAccess {
  key: string;
  label: string;
  img: string;
  isRedirect: boolean;
  redirectUrl: string | null;
  orgId: string;
}

export const javaAPI = ["1532bfa1-e3d8-42db-8987-5ae5bb479df8"];

export const bikes24JavaApi = ["ef7534de-931e-4c68-932e-626da1092f29"];

export const organizationConstants: { [key: string]: IMyAccess } = {
  "9581d96d-12a9-4444-a5ce-f32406cd7788": {
    key: "internal",
    label: "Internal",
    img: "/dashboardIcon/Loans24.svg",
    isRedirect: true,
    redirectUrl: "/dashboard/user-notification/whatsapp-template",
    orgId: "9581d96d-12a9-4444-a5ce-f32406cd7788",
  },
  "02e7c398-795a-47f5-a307-576b51436a08": {
    key: "external",
    label: "External",
    img: "/dashboardIcon/HR.svg",
    isRedirect: true,
    redirectUrl: "/dashboard/user-notification/number-scrubber",
    orgId: "02e7c398-795a-47f5-a307-576b51436a08",
  },
};

export const organizationConstantsNameHashMap = {
  internal: {
    key: "internal",
    label: "Internal",
    img: "/dashboardIcon/HR.svg",
    isRedirect: true,
    redirectUrl: "/dashboard/user-notification/whatsapp-template/",
    orgId: "9581d96d-12a9-4444-a5ce-f32406cd7788",
  },
  external: {
    key: "external",
    label: "External",
    img: "/dashboardIcon/SellarIndia.svg",
    isRedirect: true,
    redirectUrl: "/dashboard/user-notification/number-scrubber",
    orgId: "a8ec2018-11c0-4452-a857-c65b386b0356",
  },
};
